module.exports = __webpack_public_path__ + "static/media/ei06.5d310a50.png";